<template>
  <div class="document-container">
    <es-exception
      v-if="!hasModule('PRSID:MATCH:OPTIONS:UPLOADFILE')"
      exceptionMessage="Sorry, you are not authorized to access this content."
    />
    <div v-else class="columns">
      <div class="column">
        <div class="document" style="height: 100%">
          <match-options-header/>
          <new-match-message
            v-if="showNewMatchMessage"
            @newMatch="toggleNewMatchMessage"
            style="padding: 1rem 2rem"
          >
            <template v-slot:message>
              Batch submitted. Review details below.
            </template>
            <template v-slot:button-text>
              New {{ properties['BUTTON_LABEL-ASSIGN_EXISTING'] || 'Match' }}
            </template>
          </new-match-message>
          <div v-else>
            <es-loader
              v-if="loading"
              style="margin: 6.5rem"
            />
            <es-exception
              v-else-if="loadingError"
              exceptionMessage="There was an issue. Please try again or contact your administrator."
            />
            <template v-else>
              <match-options-selection/>
              <router-view
                name="matchOptionsForm"
                @batchResponse="batch = $event"
                @newMatch="toggleNewMatchMessage"
              />
            </template>
          </div>
        </div>
      </div>
      <!-- Hide Quick Tips in right panel on touch devices -->
      <div class="column is-one-quarter is-hidden-touch">
        <router-view name="matchOptionsQuickTips"/>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <match-results-pid :batch="batch"/>
      </div>
    </div>
    <!-- Put Quick Tips on bottom of page for touch devices -->
    <div class="columns">
      <div class="column is-hidden-desktop">
        <router-view name="matchOptionsQuickTips"/>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapActions, mapGetters
} from 'vuex';
import EsLoader from '@/components/EsLoader.vue';
import EsException from '@/components/EsException.vue';
import MatchOptionsHeader from '@/views/PersonId/MatchOptions/MatchOptionsHeader.vue';
import MatchOptionsSelection from '@/views/PersonId/MatchOptions/MatchOptionsSelection.vue';
import MatchResultsPid from '@/components/MatchResultsPid.vue';
import NewMatchMessage from '@/components/NewMatchMessage.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import PermissionManager from '@/mixins/PermissionManager';

export default {
  mixins: [
    BreadcrumbsManager,
    PermissionManager,
  ],
  components: {
    EsLoader,
    EsException,
    MatchOptionsHeader,
    MatchOptionsSelection,
    MatchResultsPid,
    NewMatchMessage,
  },
  data() {
    return {
      batch: {},
      batchSubmitted: null,
      loading: true,
      loadingError: null,
      showNewMatchMessage: false,
    };
  },
  created() {
    this.onLoad();
    this.setBreadcrumb([
      { text: 'Home', to: { name: 'personId' } },
      { text: 'Match Options', to: {} },
    ]);
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
  },
  methods: {
    toggleNewMatchMessage() {
      this.showNewMatchMessage = !this.showNewMatchMessage;
    },
    ...mapActions('lookups', [
      'loadSources',
    ]),
    async onLoad() {
      try {
        this.loading = true;
        this.loadingError = false;

        await this.loadSources();
      } catch (e) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
